// CustomChip.js
import React from "react";

const CustomChip = ({
  providerTitle,
  providerRating,
  currentProvider,
  onClick,
}) => {
  const isActive = currentProvider === providerTitle;

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        // padding: "6px 10px",
        borderRadius: "16px",
        fontSize: "12px",
        backgroundColor: "#E0E0E0",
        fontWeight: isActive ? "bold" : "normal",
        border: isActive ? "1px solid #232F3E" : "none",
        opacity: isActive ? 1 : 0.7,
        cursor: "pointer",
        userSelect: "none",
        margin: "3px 5px",
       alignItems:'center'
      }}
    >
    <span style={{padding: "6px 10px"}}>{providerTitle}</span>
     
      {providerRating && (
         <div style={{backgroundColor:"black",borderRadius:"16px",height:"29px",width:"52px",alignItems:'center',justifyItems:"center",paddingTop:"5.5px",paddingLeft:"5px"}}>
        <span style={{ marginLeft: 6, color: "#FFD700" /* bright gold */ }}>
          ⭐ {providerRating}
        </span>
        </div>
      )}
 
     
    </div>
  );
};

export default CustomChip;
